<template>
    <div id="cmtcwidget"></div>
</template>

<script src="./internetcable-provider.js"></script>
<style lang="scss">
    #cmTcWidgetHeadline{
        font-size: 19px !important;
    }
    #cmTcAddressHeader{
        font-size: 15px !important;
    }
</style>